
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/most-valuable-fashion-brands",
      function () {
        return require("private-next-pages/most-valuable-fashion-brands.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/most-valuable-fashion-brands"])
      });
    }
  